import { ActionType, createAction } from 'typesafe-actions';

export const declineTrendsActions = {
  setFilter: createAction('@aa/declineTrends/setFilter', action => (payload: (string | number)[]) => action(payload))
};

export type DeclineTrendsActions = ActionType<typeof declineTrendsActions>;
